import CurationPage from './CurationPage.container'

export default CurationPage
